(function () {
  const STORAGE_KEY = 'sanctified:cookie-consent';
  const CATEGORIES = ['preferences', 'analytics', 'marketing'];

  function readStored() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }

  function store(prefs) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({ ...prefs, at: new Date().toISOString() }));
    } catch (e) {
      /* private mode — consent still applied for this session */
    }
  }

  function withPrivacyApi(callback) {
    if (window.Shopify && window.Shopify.customerPrivacy) {
      callback(window.Shopify.customerPrivacy);
      return;
    }
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
        if (!error && window.Shopify.customerPrivacy) callback(window.Shopify.customerPrivacy);
      });
    }
  }

  class CookieConsent extends HTMLElement {
    connectedCallback() {
      this.bannerView = this.querySelector('[data-cookie-view="banner"]');
      this.preferencesView = this.querySelector('[data-cookie-view="preferences"]');
      this.toggles = Array.from(this.querySelectorAll('[data-cookie-category]'));

      this.querySelectorAll('[data-cookie-accept]').forEach((el) =>
        el.addEventListener('click', () => this.apply({ preferences: true, analytics: true, marketing: true }))
      );
      this.querySelector('[data-cookie-reject]').addEventListener('click', () =>
        this.apply({ preferences: false, analytics: false, marketing: false })
      );
      this.querySelector('[data-cookie-save]').addEventListener('click', () => {
        const prefs = {};
        CATEGORIES.forEach((name) => {
          const input = this.toggles.find((el) => el.dataset.cookieCategory === name);
          prefs[name] = Boolean(input && input.checked);
        });
        this.apply(prefs);
      });
      this.querySelector('[data-cookie-manage]').addEventListener('click', () => this.showPreferences());
      this.querySelector('[data-cookie-back]').addEventListener('click', () => this.showBanner());
      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && !this.preferencesView.hidden) this.showBanner();
      });

      document.querySelectorAll('[data-cookie-preferences]').forEach((el) =>
        el.addEventListener('click', () => {
          this.open();
          this.showPreferences();
        })
      );

      if (!readStored()) this.open();
    }

    open() {
      const stored = readStored() || {};
      CATEGORIES.forEach((name) => {
        const input = this.toggles.find((el) => el.dataset.cookieCategory === name);
        if (input) input.checked = Boolean(stored[name]);
      });
      this.hidden = false;
      requestAnimationFrame(() => this.classList.add('cookie-consent--visible'));
    }

    close() {
      this.classList.remove('cookie-consent--visible');
      setTimeout(() => {
        this.hidden = true;
        this.showBanner();
      }, 400);
    }

    showPreferences() {
      this.bannerView.hidden = true;
      this.preferencesView.hidden = false;
      const first = this.preferencesView.querySelector('[data-cookie-category]');
      if (first) first.focus();
    }

    showBanner() {
      this.preferencesView.hidden = true;
      this.bannerView.hidden = false;
    }

    apply(prefs) {
      store(prefs);
      withPrivacyApi((api) => {
        api.setTrackingConsent(
          {
            preferences: prefs.preferences,
            analytics: prefs.analytics,
            marketing: prefs.marketing,
            sale_of_data: prefs.marketing,
          },
          function () {}
        );
      });
      document.dispatchEvent(new CustomEvent('cookie-consent:changed', { detail: prefs }));
      this.close();
    }
  }

  if (!customElements.get('cookie-consent')) customElements.define('cookie-consent', CookieConsent);
})();
